// store/index.ts
import { createStore } from 'vuex';
import firebase from 'firebase/app';
import type { User } from 'firebase/auth';
import { getAuth } from 'firebase/auth';

const auth = getAuth();

interface State {
  apiUrl: string;
  idToken: string | null;
  user: User | null;
}

export default createStore<State>({
  state: {
    apiUrl: process.env.VUE_APP_BACKEND_URL || '', // Keep your existing API URL setup
    idToken: null,
    user: null,
  },
  getters: {
    getApiUrl: (state) => state.apiUrl,
    getIdToken: (state) => state.idToken,
    getUser: (state) => state.user,
    isAuthenticated: (state) => !!state.idToken,
  },
  mutations: {
    setApiUrl(state, url: string) {
      state.apiUrl = url;
    },
    setIdToken(state, token: string | null) {
      state.idToken = token;
    },
    setUser(state, user: User | null) {
      state.user = user;
    },
    clearAuth(state) {
      state.idToken = null;
      state.user = null;
    },
  },
  actions: {
    async refreshIdToken({ commit }) {
      const auth = getAuth();
      const user = auth.currentUser;

      if (user) {
        try {
          const freshToken = await user.getIdToken(true); // force refresh
          commit('setIdToken', freshToken);
          return freshToken;
        } catch (error) {
          console.error('Token refresh failed:', error);
          throw error;
        }
      } else {
        throw new Error('No user is currently logged in');
      }
    },
    updateApiUrl({ commit }, url: string) {
      commit('setApiUrl', url);
    },
    async fetchUser({ commit }) {
      const user = auth.currentUser;
      if (user) {
        const token = await user.getIdToken();
        commit('setUser', user);
        commit('setIdToken', token);
      }
    },
    async signOut({ commit }) {
      await auth.signOut();
      commit('clearAuth');
    },
  },
  modules: {
    // Add additional modules here if needed
  },
});
